import React, { createContext, useState, useContext } from 'react';

const SelectedProductContext = createContext();

export const useSelectedProduct = () => useContext(SelectedProductContext);

export const SelectedProductProvider = ({ children }) => {
  const [selectedProduct, setSelectedProduct] = useState('product1');
  const [isFromUI, setIsFromUI] = useState(false);
  const [loading, setLoading] = useState(0);

  return (
    <SelectedProductContext.Provider value={{
      selectedProduct, setSelectedProduct,
      isFromUI, setIsFromUI,
      loading, setLoading,
    }}>
      {children}
    </SelectedProductContext.Provider>
  );
};
